import clsx from 'clsx';

export function AvailabilityDots({ availability }) {
  if (availability) {
    return (
      <div className="flex flex-row flex-nowrap space-x-0.5">
        {availability.map((status, index) => (
          <AvailabilityDot key={index} status={status} />
        ))}
      </div>
    );
  } else {
    return null;
  }
}

function AvailabilityDot({ status }) {
  let style = 'bg-gray-300';
  switch (status) {
    case 'green':
      style = 'bg-green-400';
      break;
    case 'orange':
      style = 'bg-orange-400';
      break;
  }
  return <div className={clsx('rounded-full size-1.25', style)}></div>;
}
